import { render, staticRenderFns } from "./PartItem.vue?vue&type=template&id=d229b3d8&scoped=true&"
import script from "./PartItem.vue?vue&type=script&lang=js&"
export * from "./PartItem.vue?vue&type=script&lang=js&"
import style0 from "./PartItem.vue?vue&type=style&index=0&id=d229b3d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d229b3d8",
  null
  
)

export default component.exports